import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import UserLogin from './Components/UserHandles/UserLogin/UserLogin';
import QrDashbordNavbar from './Components/QrCodeComponents/QrDashbordNavbar';

function App() {
  return (
   <>
   <Router>
    <Routes>
    <Route path="/" element={<UserLogin />} />
       
        <Route path="/QrDashbordNavbar/*" element={<QrDashbordNavbar />} />
    </Routes>
      {/* <MasterCreation /> */}
    </Router>
   </>
  );
}

export default App;
